import { connect } from 'react-redux'
import Header from '../components/Header'
import Hello from '../components/Hello'
import Dashboard from '../components/Dashboard'
import SourceTextForm from '../components/SourceTextForm'
import LoginModal from '../components/LoginModal'
import StudyWords from '../components/StudyWords'
import FlashMessages from '../components/FlashMessages'
import UserWordsManage from '../components/UserWordsManage'
import RegistrationModal from '../components/RegistrationModal'
import React, { Component } from 'react'
import * as actionCreators from '../actions'

class App extends Component {
  constructor(props) {
    super(props);
    this.props.getProfile();
  }

  render() {
    if (this.props.user.isStart) {
      return (
        <div>
          <div className="navbar navbar-inverse"></div>
          <div className="container text-center">
            <div className="panel panel-default">
              <div className="panel-body">
                <img src="loader.svg" alt="Loading..." />
                <h3>Загрузка данных...</h3>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Header
          toggleLoginModal={this.props.toggleLoginModal}
          user={this.props.user}
          getProfile={this.props.getProfile}
          logoutUser={this.props.logoutUser}
          toggleRegistrationModal={this.props.toggleRegistrationModal}
        />

        <FlashMessages
          messages={this.props.flashMessages.messages}
          hideMessage={this.props.hideMessage}
        />

        <LoginModal
          loginModalState={this.props.loginForm.loginModalState}
          toggleLoginModal={this.props.toggleLoginModal}
          loginForm={this.props.loginForm}
          updateLogin={this.props.updateLogin}
          updatePassword={this.props.updatePassword}
          loginUser={this.props.loginUser}
        />

        {this.props.registrationForm.registrationModalState === 'open' ?
          (<RegistrationModal
            registrationModalState={this.props.registrationForm.registrationModalState}
            toggleRegistrationModal={this.props.toggleRegistrationModal}
            registrationForm={this.props.registrationForm}
            updateRegEmail={this.props.updateRegEmail}
            updateRegPassword={this.props.updateRegPassword}
            updateRegPasswordAgain={this.props.updateRegPasswordAgain}
            registrationUser={this.props.registrationUser}
          />)
          : null
        }

        {this.props.user.id ?
          <Dashboard
            toggleSourceTextModal={this.props.toggleSourceTextModal}
            getUserWords={this.props.getUserWords}
            countWords={this.props.studyWords.countWords}
            scoreLevel={this.props.studyWords.scoreLevel}
            countNewWords={this.props.studyWords.countNewWords}
            countStudiedWords={this.props.studyWords.countStudiedWords}
            userWords={this.props.studyWords.userWords}
			activity={this.props.studyWords.activity}
            toggleUserWordsManageModal={this.props.toggleUserWordsManageModal}
          />
          : <Hello toggleRegistrationModal={this.props.toggleRegistrationModal} />}

        {this.props.user.id ?
          <SourceTextForm
            toggleSourceTextModal={this.props.toggleSourceTextModal}
            modalSourceTextState={this.props.sourceTextForm.modalSourceTextState}
            updateSourceText={this.props.updateSourceText}
            sourceText={this.props.sourceTextForm.sourceText}
            isRequest={this.props.sourceTextForm.isRequest}
            sendSourceText={this.props.sendSourceText}
            wordsForAdd={this.props.sourceTextForm.wordsForAdd}
            addUserWords={this.props.addUserWords}
            checkUserWords={this.props.checkUserWords}
          />
          : null}

          <StudyWords
            toggleStudyWordsModal={this.props.toggleStudyWordsModal}
            modalStudyWordsState={this.props.studyWords.modalStudyWordsState}
            getUserWords={this.props.getUserWords}
            userWords={this.props.studyWords.userWords}
            studyTask={this.props.studyWords.studyTask}
            handleStudyAnswer={this.props.handleStudyAnswer}
            soundOn={this.props.studyWords.soundOn}
            turnSound={this.props.turnSound}
            playAudio={this.props.playAudio}
            setWordStudied={this.props.setWordStudied}
          />

          {this.props.user.id ?
            <UserWordsManage
              modalState={this.props.userWordsManage.modalState}
              paginationStep={this.props.userWordsManage.paginationStep}
              userWordsManageSetPagination={this.props.userWordsManageSetPagination}
              paginationCur={this.props.userWordsManage.paginationCur}
              toggleUserWordsManageModal={this.props.toggleUserWordsManageModal}
              userWords={this.props.studyWords.userWords}
              userWordsManageCheckWord={this.props.userWordsManageCheckWord}
              isRequest={this.props.userWordsManage.isRequest}
              deleteUserWords={this.props.deleteUserWords}
              messages={this.props.userWordsManage.messages}
              hideMessageUserWordsManage={this.props.hideMessageUserWordsManage}
            />
          : null}

          <div className="footer">
            <div className="container text-center" style={{padding: '5px 0'}}>
              <span className="text-muted">© 2022 itsmywords.ru | ingram_it@bk.ru</span>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

export default connect(mapStateToProps, actionCreators)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js